function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M24 0H0v24h24z"
}), React.createElement("path", {
  fill: "#102E8E",
  d: "M7.41 8L12 12.58 16.59 8 18 9.41l-6 6-6-6z"
}));

var SvgIcExpandMore = function SvgIcExpandMore(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTI0IDBIMHYyNGgyNHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjMTAyRThFIiBkPSJNNy40MSA4TDEyIDEyLjU4IDE2LjU5IDggMTggOS40MWwtNiA2LTYtNnoiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgIcExpandMore as ReactComponent };